/* PATOYS app-install prompt: phones only, once per session, bottom sheet.
   Appears after 5 seconds or on the first scroll (whichever comes first), never over the header. */
(function () {
  var script = document.querySelector('script[data-pt-app-prompt]');
  if (!script) return;
  if (!/Mobi|Android/i.test(navigator.userAgent)) return;

  if (window.location.pathname.indexOf('/products/') !== -1) return;

  var KEY = 'appPromptShown';
  try {
    if (sessionStorage.getItem(KEY)) return;
  } catch (e) {}

  var shown = false;
  var timer = null;

  function remove() {
    var el = document.getElementById('pa-app-prompt');
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function show() {
    if (shown) return;
    shown = true;
    window.clearTimeout(timer);
    window.removeEventListener('scroll', show);
    try {
      sessionStorage.setItem(KEY, '1');
    } catch (e) {}

    var box = document.createElement('div');
    box.id = 'pa-app-prompt';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-label', script.getAttribute('data-title') || '');
    box.style.cssText =
      'position:fixed;bottom:0;left:0;right:0;background:#fff;box-shadow:0 -4px 20px rgba(0,0,0,0.15);' +
      'padding:16px;z-index:9999;border-radius:16px 16px 0 0;font-family:sans-serif;';

    var head = document.createElement('div');
    head.style.cssText = 'display:flex;align-items:center;margin-bottom:12px;';

    var logo = document.createElement('img');
    logo.src = script.getAttribute('data-logo') || '';
    logo.alt = '';
    logo.width = 48;
    logo.height = 48;
    logo.style.cssText = 'width:48px;height:48px;border-radius:10px;margin-right:12px;';
    head.appendChild(logo);

    var copy = document.createElement('div');
    var title = document.createElement('strong');
    title.style.fontSize = '15px';
    title.textContent = script.getAttribute('data-title') || '';
    var sub = document.createElement('span');
    sub.style.cssText = 'display:block;font-size:12px;color:#666;';
    sub.textContent = script.getAttribute('data-subtitle') || '';
    copy.appendChild(title);
    copy.appendChild(sub);
    head.appendChild(copy);
    box.appendChild(head);

    var actions = document.createElement('div');
    actions.style.cssText = 'display:flex;gap:10px;';

    var open = document.createElement('a');
    open.href = script.getAttribute('data-url') || '#';
    open.textContent = script.getAttribute('data-open') || '';
    open.style.cssText =
      'flex:1;background:#e63946;color:#fff;text-align:center;padding:12px;border-radius:8px;' +
      'text-decoration:none;font-weight:bold;';
    actions.appendChild(open);

    var dismiss = document.createElement('button');
    dismiss.type = 'button';
    dismiss.textContent = script.getAttribute('data-continue') || '';
    dismiss.style.cssText =
      'flex:1;background:#f5f5f5;border:none;padding:12px;border-radius:8px;cursor:pointer;font-weight:bold;';
    dismiss.addEventListener('click', remove);
    actions.appendChild(dismiss);

    box.appendChild(actions);
    document.body.appendChild(box);
  }

  timer = window.setTimeout(show, 5000);
  window.addEventListener('scroll', show, { passive: true, once: true });
})();